import { createAsyncThunk } from "@reduxjs/toolkit";

//Include Both Helper File with needed methods
import {
  getEvents as getEventsApi,
  getAttendance as getAttendanceApi,
  addNewEvent as addNewEventApi,
  updateEvent as updateEventApi,
  deleteEvent as deleteEventApi,
  getCategories as getCategoriesApi,
  getUpCommingEvent as getUpCommingEventApi
} from "../../helpers/fakebackend_helper";

export const getEvents = createAsyncThunk("calendar/getEvents", async () => {
  try {

    // const response = await getEventsApi();

    const response = [
      {
        "id": 153,
        "title": "On Duty",
        "start": "2025-03-31T16:00:00.000Z",
        "className": "bg-primary-subtle text-primary",
        "location": "San Francisco, US",
        "allDay": false,
        "extendedProps": {
          "department": "All Day Event"
        },
        "description": "An all-day event is an event that lasts an entire day or longer"
      },
      {
        "id": 136,
        "title": "Visit Online Course",
        "start": "2025-04-14T16:00:00.000Z",
        "end": "2025-04-17T16:00:00.000Z",
        "allDay": false,
        "className": "bg-warning-subtle text-warning",
        "location": "San Francisco, US",
        "extendedProps": {
          "department": "Long Event"
        },
        "description": "Long Term Event means an incident that last longer than 12 hours."
      },
      {
        "id": 999,
        "title": "Client Meeting with Alexis",
        "start": "2025-05-12T12:00:00.000Z",
        "end": "2025-05-14T08:00:00.000Z",
        "allDay": false,
        "className": "bg-danger-subtle text-danger",
        "location": "California, US",
        "extendedProps": {
          "department": "Meeting with Alexis"
        },
        "description": "A meeting is a gathering of two or more people that has been convened for the purpose of achieving a common goal through verbal interaction, such as sharing information or reaching agreement."
      },
      {
        "id": 991,
        "title": "Repeating Event",
        "start": "2025-04-24T08:00:00.000Z",
        "end": "2025-04-29T08:00:00.000Z",
        "allDay": false,
        "className": "bg-primary-subtle text-primary",
        "location": "Las Vegas, US",
        "extendedProps": {
          "department": "Repeating Event"
        },
        "description": "A recurring or repeating event is simply any event that you will occur more than once on your calendar. "
      },
      {
        "id": 112,
        "title": "Meeting With Designer",
        "start": "2025-04-20T04:30:00.000Z",
        "allDay": false,
        "className": "bg-success-subtle text-success",
        "location": "Head Office, US",
        "extendedProps": {
          "department": "Meeting"
        },
        "description": "Tell how to boost website traffic"
      },
      {
        "id": 113,
        "title": "Weekly Strategy Planning",
        "start": "2025-04-28T16:00:00.000Z",
        "end": "2025-04-30T16:00:00.000Z",
        "allDay": false,
        "className": "bg-danger-subtle text-danger",
        "location": "Head Office, US",
        "extendedProps": {
          "department": "Lunch"
        },
        "description": "Strategies for Creating Your Weekly Schedule"
      },
      {
        "id": 875,
        "title": "Birthday Party",
        "start": "2025-04-21T11:00:00.000Z",
        "allDay": false,
        "className": "bg-success-subtle text-success",
        "location": "Los Angeles, US",
        "extendedProps": {
          "department": "Birthday Party"
        },
        "description": "Family slumber party – Bring out the blankets and pillows and have a family slumber party! Play silly party games, share special snacks and wind down the fun with a special movie."
      },
      {
        "id": 783,
        "title": "Click for Google",
        "start": "2025-04-27T16:00:00.000Z",
        "end": "2025-04-28T16:00:00.000Z",
        "url": "http://google.com/",
        "className": "bg-dark-subtle text-body"
      },
      {
        "id": 456,
        "title": "Project Discussion with Team",
        "start": "2025-05-13T12:00:00.000Z",
        "end": "2025-05-14T08:00:00.000Z",
        "allDay": false,
        "className": "bg-info-subtle text-info",
        "location": "Head Office, US",
        "extendedProps": {
          "department": "Discussion"
        },
        "description": "Tell how to boost website traffic"
      },
      {
        "id": 1,
        "title": "World Braille Day",
        "start": "2022-01-01T00:00:00.000Z",
        "end": "2022-01-08T00:00:00.000",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 2,
        "title": "World Leprosy Day",
        "start": "2022-05-04",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 3,
        "title": "International Mother Language Day",
        "start": "2022-02-21",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 4,
        "title": "International Women's Day",
        "start": "2022-03-08",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 5,
        "title": "World Thinking Day",
        "start": "2022-02-22",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 6,
        "title": "International Mother Language Day",
        "start": "2022-03-21",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 7,
        "title": "World Water Day",
        "start": "2022-03-22",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 8,
        "title": "World Health Day",
        "start": "2022-04-07",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 9,
        "title": "International Special Librarians Day",
        "start": "2022-04-16",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      },
      {
        "id": 10,
        "title": "Earth Day",
        "start": "2022-04-22",
        "className": "bg-info-subtle text-info",
        "allDay": true,
        "description": "N.A.",
        "location": "N.A."
      }
    ];

    return response;
  } catch (error) {
    return error;
  }
});

export const addNewEvent = createAsyncThunk("calendar/addNewEvent", async (event) => {
  try {
    const response = addNewEventApi(event);
    return response;
  } catch (error) {
    return error;
  }
});

export const updateEvent = createAsyncThunk("calendar/updateEvent", async (event) => {
  try {
    const response = updateEventApi(event);
    const modifiedevent = await response;
    return modifiedevent;
  } catch (error) {
    return error;
  }
});

export const deleteEvent = createAsyncThunk("calendar/deleteEvent", async (event) => {
  try {
    const response = deleteEventApi(event);
    return response;
  } catch (error) {
    return error;
  }
});

export const getCategories = createAsyncThunk(
  "calendar/getCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCategoriesApi();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch categories");
    }
  }
);

export const getUpCommingEvent = createAsyncThunk("calendar/getUpCommingEvent", async () => {
  try {
    const response = getUpCommingEventApi()
    return response;
  } catch (error) {
    return error;
  }
})

export const resetCalendar = createAsyncThunk("calendar/resetCalendar", async () => {
  try {
    const response = '';
    return response;
  } catch (error) {
    return error;
  }
})